<template>
  <div class="page-contrats">
    <landing-header />

    <main>
      <section class="hero-contrats">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-16">
          <div class="lg:w-1/2">
            <span class="badge-contrat">Fidélisation & Récurrence</span>
            <h1 class="text-4xl md:text-6xl font-black text-gray-900 mb-6 leading-tight">
              Sécurisez votre <br />
              <span class="gradient-text">chiffre d'affaires</span>
            </h1>
            <p class="text-xl text-gray-600 mb-8 leading-relaxed">
              Transformez vos contrats d'entretien en levier de croissance. Automatisez les suivis, planifiez sereinement vos visites et offrez une transparence totale à vos clients.
            </p>
            <div class="flex flex-wrap gap-4">
              <a href="/contact"><button class="btn-primary">Demander une démonstration</button></a>
              <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
            </div>
          </div>
          
          <div class="lg:w-1/2 w-full">
            <div class="contract-card shadow-2xl">
              <div class="contract-badge-top">Contrat Actif</div>
              <div class="contract-inner">
                <div class="c-header">
                  <i class="fa-solid fa-file-signature"></i>
                  <div>
                    <h3>Maintenance PAC Résidentielle</h3>
                    <p>Client : Jean Dupont</p>
                  </div>
                </div>
                <div class="c-stats">
                  <div class="c-stat">
                    <span>Dernière visite</span>
                    <strong>12 Janv. 2024</strong>
                  </div>
                  <div class="c-stat">
                    <span>Prochaine échéance</span>
                    <strong class="text-orange-600">Janv. 2025</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-white border-t border-gray-100">
        <div class="max-w-7xl mx-auto px-4">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            <div class="arg-item">
              <div class="arg-icon"><i class="fa-solid fa-layer-group"></i></div>
              <h3 class="text-xl font-bold mb-4">Gestion multi-énergies</h3>
              <p class="text-gray-600">Chaudières, PAC, Climatisation : créez des contrats adaptés à chaque équipement et client.</p>
            </div>
            <div class="arg-item">
              <div class="arg-icon"><i class="fa-solid fa-wand-magic-sparkles"></i></div>
              <h3 class="text-xl font-bold mb-4">Génération Automatique</h3>
              <p class="text-gray-600">Produisez vos documents contractuels et annexes en un clic, sans risque d'erreur de saisie.</p>
            </div>
            <div class="arg-item">
              <div class="arg-icon"><i class="fa-solid fa-bell"></i></div>
              <h3 class="text-xl font-bold mb-4">Suivi des échéances</h3>
              <p class="text-gray-600">Ne perdez plus aucun renouvellement. Termoflow vous alerte sur les visites d'entretien à planifier.</p>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-gray-50">
        <div class="max-w-7xl mx-auto px-4">
          <div class="flex flex-col lg:flex-row items-center gap-20">
            <div class="lg:w-1/2">
              <h2 class="text-3xl font-bold text-gray-900 mb-6">Un lien direct avec le terrain</h2>
              <p class="text-gray-600 mb-8">Chaque contrat est relié aux interventions réelles. Suivez en temps réel l'exécution de vos engagements contractuels et accédez à l'historique complet des signatures.</p>
              
              <div class="feature-line">
                <i class="fa-solid fa-check-double text-green-500"></i>
                <span>Preuve d'exécution par rapport d'intervention</span>
              </div>
              <div class="feature-line">
                <i class="fa-solid fa-check-double text-green-500"></i>
                <span>Archivage automatique des documents signés</span>
              </div>
              <div class="feature-line">
                <i class="fa-solid fa-check-double text-green-500"></i>
                <span>Visibilité totale via le Portail Client</span>
              </div>
            </div>
            <div class="lg:w-1/2">
               <div class="timeline-visual">
                  <div class="t-step active">Signature Contrat (Janv 2024)</div>
                  <div class="t-step active">Entretien Annuel (Mai 2024)</div>
                  <div class="t-step">Prochain rappel (Janv 2025)</div>
               </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4">
          <h2 class="text-center text-3xl font-bold mb-16">Les bénéfices pour votre entreprise</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div class="benefit-card-contrat">
              <h4>Visibilité</h4>
              <p>Anticipez votre charge de travail future.</p>
            </div>
            <div class="benefit-card-contrat">
              <h4>Stabilité</h4>
              <p>Lissez votre chiffre d'affaires sur l'année.</p>
            </div>
            <div class="benefit-card-contrat">
              <h4>Fidélité</h4>
              <p>Renforcez le lien long terme avec vos clients.</p>
            </div>
            <div class="benefit-card-contrat">
              <h4>Zéro Oubli</h4>
              <p>Garantissez la sécurité des installations suivies.</p>
            </div>
          </div>
        </div>
      </section>

      <section class="py-20 text-center">
        <div class="max-w-3xl mx-auto px-4">
          <h2 class="text-4xl font-black text-gray-900 mb-8">Stabilisez votre activité dès maintenant</h2>
          <div class="flex flex-col sm:flex-row justify-center gap-4">
             <a href="/contact"><button class="btn-primary-large">Demander une démonstration</button></a>
             <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
          </div>
        </div>
      </section>

      <landing-roi />
      <landing-avis />
    </main>

    <landing-footer />
  </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue'
import LandingFooter from './LandingFooter.vue'
import LandingAvis from './LandingAvis.vue'
import LandingROI from './LandingROI.vue'

export default {
  name: 'ContratsPage',
  components: {
    LandingHeader,
    LandingFooter,
    LandingAvis,
    'landing-roi': LandingROI
  }
}
</script>

<style scoped>
/* --- UTILS --- */
.gradient-text {
  background: linear-gradient(to right, #f97316, #ef4444);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* --- HERO --- */
.hero-contrats {
  padding: 10rem 0 6rem;
  background: radial-gradient(circle at top right, #fff7ed, transparent 35%);
}

.badge-contrat {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #f0f9ff;
  color: #0369a1;
  font-weight: 800;
  font-size: 0.75rem;
  border-radius: 9999px;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
}

/* --- CONTRACT CARD --- */
.contract-card {
  background: white;
  border-radius: 2rem;
  padding: 2.5rem;
  border: 1px solid #e5e7eb;
  position: relative;
}
.contract-badge-top {
  position: absolute;
  top: -12px;
  right: 2rem;
  background: #16a34a;
  color: white;
  padding: 0.4rem 1rem;
  border-radius: 9999px;
  font-size: 0.7rem;
  font-weight: 800;
}
.c-header { display: flex; gap: 1.5rem; align-items: center; margin-bottom: 2rem; }
.c-header i { font-size: 2.5rem; color: #f97316; }
.c-header h3 { font-weight: 900; font-size: 1.25rem; }
.c-header p { font-size: 0.85rem; color: #6b7280; }

.c-stats { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; border-top: 1px solid #f3f4f6; padding-top: 2rem; }
.c-stat span { display: block; font-size: 0.7rem; color: #9ca3af; text-transform: uppercase; font-weight: 800; }
.c-stat strong { font-size: 0.95rem; }

/* --- ARGUMENTS --- */
.arg-icon { width: 3.5rem; height: 3.5rem; background: #fff7ed; color: #f97316; border-radius: 1rem; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; margin-bottom: 1.5rem; }
.arg-item { padding: 1rem; }

/* --- TIMELINE --- */
.timeline-visual { border-left: 2px solid #e5e7eb; padding-left: 2rem; }
.t-step { position: relative; padding-bottom: 2rem; font-weight: 700; color: #9ca3af; }
.t-step::before { content: ''; position: absolute; left: -2.45rem; top: 0.25rem; width: 0.8rem; height: 0.8rem; background: white; border: 2px solid #e5e7eb; border-radius: 50%; }
.t-step.active { color: #1f2937; }
.t-step.active::before { background: #f97316; border-color: #f97316; }

/* --- BENEFITS --- */
.benefit-card-contrat { background: #f9fafb; padding: 2.5rem 1.5rem; border-radius: 1.5rem; text-align: center; border: 1px solid #f3f4f6; }
.benefit-card-contrat h4 { font-weight: 900; color: #f97316; margin-bottom: 1rem; font-size: 1.1rem; }
.benefit-card-contrat p { font-size: 0.9rem; color: #6b7280; font-weight: 600; }

.feature-line { display: flex; align-items: center; gap: 1rem; font-weight: 700; color: #4b5563; margin-bottom: 1rem; }

/* --- BUTTONS --- */
.btn-primary { background: linear-gradient(to right, #f97316, #ef4444); color: white; padding: 1rem 2.5rem; border-radius: 9999px; font-weight: 700; border: none; }
.btn-primary-large { background: #f97316; color: white; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; border: none; font-size: 1.1rem; }
.btn-outline-large { border: 2px solid #e5e7eb; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; color: #1f2937; text-decoration: none; display: inline-block; }

@media (max-width: 1024px) {
  .hero-contrats { text-align: center; padding-top: 8rem; }
  .hero-contrats .flex { flex-direction: column; }
  .contract-card { margin-top: 4rem; }
}
</style>